var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":_vm.title,"visible":_vm.show,"width":_vm.width,"destroy-on-close":"","center":""},on:{"close":_vm.close,"update:visible":function($event){_vm.show=$event}}},[_vm._t("title"),_vm._t("content"),_vm._t("footer")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }